import React from 'react';
import { useShowContext } from 'framework/show';
import { Typography } from '@mui/material';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const AssignmentDateRangeField = () => {
  const { data } = useShowContext();
  const startDate = data.getValueBySource('startDate');
  const endDate = data.getValueBySource('endDate');

  return (
    <Typography color="textSecondary">
      {startDate && endDate ? `${startDate} — ${endDate}` : EMPTY_VALUE_INDICATOR}
    </Typography>
  );
};
export default AssignmentDateRangeField;
